export const getDomain = () => {
    if (typeof window !== 'undefined') {
        return window.location.host;
    }
    return 'unknown';
};
export const getDomainFromString = (url) => {
    const matches = url.match(/^https?:\/\/(?:www\.)?([^/?#]+)(?:[/?#]|$)/i);
    if (matches.length > 0) {
        return matches[1];
    }
    return null;
};
export const getQueryVariable = (variable) => {
    const query = window && window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
};
export const queryStringToObject = () => {
    // remove '?' from string and split into array.
    if (!window.location.search || !window.location.search.length) {
        return {};
    }
    const queryArray = decodeURIComponent(window && window.location.search)
        .substring(1)
        .split('&');
    const queryObject = {};
    queryArray.forEach((el) => {
        const pair = el.split('=');
        // replace below removes all whitespaces from key names, trim only removes from ends.
        const key = pair[0].replace(/\s+/g, '');
        let val = pair[1].trim();
        if (val === 'false' || val === 'true') {
            // convert to boolean
            val = val === 'true';
        }
        queryObject[key] = val;
    });
    return queryObject;
};
